import highFiveLockup from './images/HighFive_LockUp.svg';
import highFivePrideLockup from './images/H5_Pride_Nike.jpg';
import highFiveNarrow from './images/HighFive_Logo_Swoosh_LeftAligned.svg'
import highFiveLockupConverse from './images/HighFive_Converse_vertical.svg';
import highFivePrideLockupConverse from './images/H5_Pride_Converse.jpg';
import highFiveLockupConverseHorizontal from './images/HighFive_Converse_horizontal.svg';

const currentNikeLogo = ( company ) => {
    const now = new Date();
    const currentMonth = now.getMonth(); // 0 = Jan

    if (currentMonth === 5 && company === 'nike') return highFivePrideLockup;
    else if (currentMonth === 5 && company === 'converse') return highFivePrideLockupConverse;
    else if (company === 'converse') return highFiveLockupConverse;

    return highFiveLockup
  };

export default {
    nike: {
      highFiveLogo: currentNikeLogo('nike'),
      highFiveNarrowLogo: highFiveNarrow,
      valueName: "Maxim",
      valueHomepage: "https://maxims.nike.com/about/",
      loginPage_headerOne: "Let's Recognize Our Team",
      loginPage_headerOneDescription: `Recognize your teammates for
      their hard work, innovative spirit and embodiment
      of the Nike Maxims! The Nike High Five program
      empowers you to acknowledge good
      work when you see it!`,
      loginPage_headerTwo: `The Maxims`,
      loginPage_headerTwoDescription:`Our Maxims represent our core values and
      beliefs and feature the fundamental
      behaviors that apply to all employees – no matter your role, location or level.`,
      loginPage_headerTwoLink: `https://maxims.nike.com/about/`,
      values: [
          {
              id: '1',
              name: "Serve Athletes*",
              description: `This Maxim is tied to our mission and is at the center of all that we do.
              Nike employees create product and experiences to serve athletes — or we work
              in support of the teams that do. No matter the type of work we do, serving
              athletes is our north star.`
          },
          {
            id: '2',
            name: "Create the Future of Sport",
            description: `This Maxim reflects our commitment to innovation. It establishes Nike as a
            place where inventors and dreamers can achieve the unimaginable.`
        },
        {
            id: '3',
            name: "Be on the Offense Always",
            description: `Nike is a growth company — and we demonstrate it by our focus on the
            consumer. This Maxim represents all aspects of our business and our
            determination to win.`
        },
        {
            id: '4',
            name: "Do the Right Thing",
            description: `This Maxim reflects our belief in accountability to each other and
            recognizes the importance of how we connect to and serve our communities.`
        },
        {
            id: '5',
            name: "Win as a Team",
            description: `Employees provided consistent feedback that teamwork was missing in the
            previous Maxims. Now it stands by itself as a testament to our commitment to
            team.`
        }
      ]

    },
    converse: {
      highFiveLogo: currentNikeLogo('converse'),
      highFiveNarrowLogo: highFiveLockupConverseHorizontal,
      valueName: "Value",
      valueHomepage: "https://converseconnect.nike.com/home/news/converse_news/2883/",
      loginPage_headerOne: "Let's Recognize Our Team",
      loginPage_headerOneDescription: `Recognize your teammates for
      their hard work, innovative spirit and embodiment
      of the Converse Values! The High Five program
      empowers you to acknowledge good
      work when you see it!`,
      loginPage_headerTwo: `The Converse Values`,
      loginPage_headerTwoDescription:`Our Values represent the beliefs and behaviors that lie at
      the heart of everything we do. These five simple, actionable phrases capture what drives
      us forward as a Brand.`,
      loginPage_headerTwoLink: `https://converseconnect.nike.com/home/news/converse_news/2883/`,
      values: [
        {
            id: '6',
            name: "Serve Youth",
            description: `We don’t just show up – we’re all in. Creating a deep understanding for
            how youth seek to express themselves is how we deliver relevant solutions. We recognize
            the power of youth to point the way forward. Their passion fuels our passion.
            Our work amplifying and enabling the voice of youth is never finished.`
        },
        {
          id: '7',
          name: "Spark Progress",
          description: `We indulge our thirst for knowledge. Play. Poke. Question. Dream.
          That’s how we unearth opportunity and excite possibility. Curiosity is the
          engine of our growth. We build on ideas, not break them. Instead of
          ‘why?’ we say ‘why not!’. Youth culture moves fast, we adapt by
          staying open, making transformation our craft. It’s in our DNA.`
      },
      {
          id: '8',
          name: "Dare Greatly",
          description: `We are independent enough not to follow. We believe in ourselves
          and our ideas so strongly, our confidence compels us to action.
          Only we can create the change we seek. We’re competitive, moving quickly and
          decisively. With change as the only constant in this modern world, evolving
          immediately is how we stay ahead. Agility is our edge.`
      },
      {
          id: '9',
          name: "Do the Right Thing",
          description: `We strive to be the best version of ourselves – even when it’s hard.
          Practicing truth, acting with authenticity and embracing positivity. Real people
          do real things. We are compassionate and seek to understand each other, our community
          and our future. We imagine how we will make things better while we make better things.`
      },
      {
          id: '10',
          name: "Win Together",
          description: `We value one another above all. Building a culture of mutual respect by
          listening as often as we speak up. We challenge each other, but we have each other’s
          back. Always. We derive our strength from our unique perspectives and experiences.
          We see beauty in diversity and its power to provoke new ways of thinking and take
          us to new places.`
      }
    ]
    }
  }


// WEBPACK FOOTER //
// ./src/copy.js